import { SolutionPageConfig } from './solution-page.model';

function faqItems(count = 3): SolutionPageConfig['faqItems'] {
  return Array.from({ length: count }, (_, i) => ({ index: i + 1 }));
}

function page(num: number, heroEyebrowKey: string, shortIcons: string[]): SolutionPageConfig {
  return {
    i18nPrefix: `SOLUTION${num}`,
    heroEyebrowKey,
    shortFeatures: shortIcons.map((icon, i) => ({ icon, index: i + 1 })),
    faqItems: faqItems(3),
    heroSubtitleKey: 'TEXT',
  };
}

export const SOLUTION_PAGE_CONFIGS: Record<number, SolutionPageConfig> = {
  1: page(1, 'HOME.FEATURE_AUTOMATE_OPERATIONS_TITLE', ['lni-pulse', 'lni-calculator', 'lni-bar-chart']),
  2: page(2, 'HOME.FEATURE_COLLECT_PAYMENTS_ONLINE_TITLE', ['lni-wallet', 'lni-credit-cards', 'lni-reload']),
  3: page(3, 'HOME.FEATURE_PROFESSIONAL_REPORT_TITLE', ['lni-bar-chart', 'lni-checkmark-circle', 'lni-share']),
  4: page(4, 'HOME.FEATURE_SCORING_TITLE', ['lni-files', 'lni-shield', 'lni-alarm']),
  5: page(5, 'HOME.FEATURE_INVENTORY_TITLE', ['lni-package', 'lni-timer', 'lni-calculator']),
  6: page(6, 'HOME.FEATURE_UTILITIES_TITLE', ['lni-bolt', 'lni-files', 'lni-alarm']),
};
